module.exports = {
          srcSet: __webpack_public_path__ + "public/f80a77c34b7997a54653352e0468b4d1-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/f80a77c34b7997a54653352e0468b4d1-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/f80a77c34b7997a54653352e0468b4d1-80.png",
          toString:function(){return __webpack_public_path__ + "public/f80a77c34b7997a54653352e0468b4d1-80.png"},
          
          width: 80,
          height: 80
        }